import { App } from "antd";
import { useCallback } from "react";
import { __ } from "../../../utils/i18n.js";
const defaultCopy = {
    title: __("Discard unsaved changes?"),
    body: __("Your changes haven't been saved yet. Closing now will discard them."),
    okText: __("Discard changes"),
    cancelText: __("Keep editing")
};
function useFormDirtyGuard(form, onClose, copy = {}) {
    const { modal } = App.useApp();
    return useCallback(()=>{
        if (!form.isFieldsTouched()) {
            onClose();
            return;
        }
        const resolved = {
            ...defaultCopy,
            ...copy
        };
        modal.confirm({
            title: resolved.title,
            content: resolved.body,
            okText: resolved.okText,
            cancelText: resolved.cancelText,
            okButtonProps: {
                danger: true
            },
            onOk: onClose
        });
    }, [
        form,
        onClose,
        modal,
        copy.title,
        copy.body,
        copy.okText,
        copy.cancelText
    ]);
}
export { useFormDirtyGuard };
